import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38787ba8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "not-found" }
const _hoisted_2 = { class: "not-found__body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "not-found__content" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "not-found__404" }, "404"),
  /*#__PURE__*/_createElementVNode("p", { class: "not-found__paragraph" }, "متاسفانه صفحه مورد نظرتان پیدا نشد.")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "29",
  height: "28"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FFF",
    d: "M22.6 27.589H6.975c-3.55 0-6.438-2.823-6.438-6.294v-9.381c0-1.717 1.095-3.694 2.753-4.953l6.95-5.318h.01C12.127.51 15.483.28 17.671 1.464l8.022 5.481c1.541 1.049 2.751 3.31 2.751 5.965v8.399c0 3.463-2.888 6.28-5.844 6.28zm3.897-14.679c0-2.035-.898-3.712-1.919-4.408L16.553 3.19c-.753-1.07-3.917-.51-5.333-.047L4.224 8.46c-.927.704-1.74 2.318-1.74 3.454v9.381c0 2.424 2.015 4.395 4.491 4.395H22.6c1.882 0 3.897-1.965 3.897-4.381V12.91zM14.49 22.524c-.537 0-.973.466-.973-.949v-3.799c0-.524.436-.949.973-.949.79 0 .974.425.974.949v3.799c0 1.415-.184.949-.974.949z"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "بازگشت به صفحه اصلی", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo = _resolveComponent("logo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: 'Home' },
        style: {"z-index":"11"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_logo, { width: "135" })
        ]),
        _: 1
      }),
      _hoisted_3,
      _createVNode(_component_router_link, {
        class: "not-found__link",
        to: { name: 'Home' }
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}